var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownTableColumn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.4345 4.9819C2.4055 4.95364 2.2815 4.84697 2.1795 4.7476C1.538 4.16504 0.488 2.64532 0.1675 1.84989C0.116 1.7291 0.007 1.42369 0 1.26051C0 1.10416 0.036 0.955106 0.109 0.812875C0.211 0.635574 0.3715 0.493343 0.561 0.415408C0.6925 0.365237 1.086 0.287303 1.093 0.287303C1.5235 0.209368 2.223 0.166504 2.996 0.166504C3.7325 0.166504 4.4035 0.209368 4.8405 0.273177C4.8475 0.280483 5.3365 0.358418 5.504 0.443659C5.81 0.600016 6 0.905423 6 1.23226V1.26051C5.9925 1.47337 5.8025 1.92101 5.7955 1.92101C5.4745 2.67357 4.476 4.15822 3.8125 4.75491C3.8125 4.75491 3.642 4.92296 3.5355 4.99602C3.3825 5.11 3.193 5.1665 3.0035 5.1665C2.792 5.1665 2.595 5.10269 2.4345 4.9819Z",
    fill: "#030229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownTableColumn);
export default __webpack_public_path__ + "static/media/arrowDownTableColumn.289945d6068c02a037d61ed62a9346e2.svg";
export { ForwardRef as ReactComponent };